// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__kkV2r","insightsList":"newBusinessInsightsMenu_insightsList__pxHU3","active":"newBusinessInsightsMenu_active__308Ev"};